import { mmtTheme } from './mmtTheme';

export const tazamaTheme = {
  ...mmtTheme,

  baseGray10: '#f0f0f3',
  baseGray20: '#e9e9ed',
  colorPrimary: '#82B88A',
  // Primary
  colorPrimary1: '#D9E9DC',
  colorPrimary2: '#CDE1D0',
  colorPrimary3: '#B4D3B9',
  colorPrimary4: '#9BC4A1',
  colorPrimary5: '#82B58A',
  colorPrimary6: '#82B88A',
  colorPrimary7: '#82B88A',
  colorPrimary8: '#384E3B',
  colorPrimary9: '#2B3D2E',
  colorPrimary10: '#1F2C20',
  // Secondary
  colorSecondary3: '#699370',
  colorSecondary: '#699370',
}
